/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimension } from './RiskDimension';
import { RiskDimensionFromJSON, RiskDimensionFromJSONTyped, RiskDimensionToJSON } from './RiskDimension';

/**
 *
 * @export
 * @interface RiskDimensionLabelDetail
 */
export interface RiskDimensionLabelDetail {
  /**
   *
   * @type {number}
   * @memberof RiskDimensionLabelDetail
   */
  readonly id: number;
  /**
   *
   * @type {RiskDimension}
   * @memberof RiskDimensionLabelDetail
   */
  readonly dimension: RiskDimension;
  /**
   *
   * @type {string}
   * @memberof RiskDimensionLabelDetail
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof RiskDimensionLabelDetail
   */
  threshold: number;
}

/**
 * Check if a given object implements the RiskDimensionLabelDetail interface.
 */
export function instanceOfRiskDimensionLabelDetail(value: object): value is RiskDimensionLabelDetail {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('dimension' in value) || value['dimension'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('threshold' in value) || value['threshold'] === undefined) return false;
  return true;
}

export function RiskDimensionLabelDetailFromJSON(json: any): RiskDimensionLabelDetail {
  return RiskDimensionLabelDetailFromJSONTyped(json, false);
}

export function RiskDimensionLabelDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskDimensionLabelDetail {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    dimension: RiskDimensionFromJSON(json['dimension']),
    name: json['name'],
    threshold: json['threshold'],
  };
}

export function RiskDimensionLabelDetailToJSON(value?: Omit<RiskDimensionLabelDetail, 'id' | 'dimension'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    threshold: value['threshold'],
  };
}
